/**
 * Foto de perfil — upload e atualização somente via API (livestay-backend).
 */
import { apiJson } from '@/lib/api-client';
import { getApiEndpoint, getUserImageUrl } from '@/config/api';
import { authBearerOnly } from '@/lib/api-client';

export class UserPhotoService {
  static async uploadUserPhoto(file: File, userId: number): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId.toString());

    const response = await fetch(getApiEndpoint('api/upload/user-photo'), {
      method: 'POST',
      headers: authBearerOnly(),
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Erro no upload: ${response.statusText}`);
    }

    const result = (await response.json()) as { filename: string };
    if (!result?.filename) {
      throw new Error('Upload concluído sem nome de arquivo.');
    }
    return result.filename;
  }

  static async updateUserPhoto(
    userId: number,
    filename: string,
  ): Promise<boolean> {
    await apiJson(`api/auth/profile/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify({ profile_photo: filename }),
    });
    return true;
  }

  static getUserPhotoUrl(userId: number, filename: string): string {
    return getUserImageUrl(userId, filename);
  }
}
